module.exports = __webpack_public_path__ + "img/help3.54319391.png";